<template>
  <div class="flex items-center gap-2 rounded-[4px] border-2 border-emo-yellow bg-yellow-100 p-2" role="alert">
    <div>
      <gv-icon name="error" size="lg" />
    </div>
    <gv-type uplifted-variant="body-1">
      {{ t('5q66x-HVsUSKxu1q72A4t') }}
    </gv-type>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
